module.exports = __webpack_public_path__ + "static/media/sem-imagem.157b9426.jpg";